<template>
    
    <router-link :to="to" class="show d_f" :class="'show-'+size">
        <div class="d_f d_f_c jc_sb w_1">
            <img :src="img" alt="">
            <p>{{title}}</p>
        </div>
    </router-link>


</template>

<script>
export default {
    
    props : {
        to : {
            type : String,
            default(){
                return '/'
            }
        },
        size : {
            type : String,
            validator: function (value) {
                return ['min', 'small', 'max'].indexOf(value) !== -1
            },
            default : 'small'   
        },
        img : String,
        title : String
    }

}
</script>

<style lang="scss" scoped>

    p{
            margin-bottom: 0;
            text-align: center;
            overflow: hidden;
            white-space: nowrap;
            text-overflow:ellipsis;
            padding: 2.66vw 1.33vw;
    }
    .show-max{
        width: 390px;
        height: 320px;
        margin-bottom: 50px;
        img{
            display: block;
            width: 100%;
            height: 274px;
        }
        p{
            color: #000;
        }
    }
    .show-small{
        width: 260px;
        height: 300px;
        margin-bottom: 50px;
        img{
            display: block;
            width: 260px;
            height: 260px;
        }
        p{
            margin-bottom: 0 !important;
            text-align: center;
        }
    }
    .show-min{
        width: 42.021vw;
        img{
            height: 42.021vw;
            width: 42.021vw;
            border-radius: 1.33vw;
            background-color: #fff;
        }
        p{
            color: #000;
            font-size: 3.458vw;
            // padding: 1.33vw;
        }
    }

</style>